import React from "react";
import "./scss/App.scss";
import "./ i18n";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavBar from "./Components/NavBar";
import Footer from "./Components/Footer";
import Hero from "./Components/Hero";
import BottomHero from "./Components/BottomHero";
import MemberCarousel from "./Components/MemberCarousel";
import Slide from "./Components/ResearchSlide";
import AlumContact from "./Components/AlumContact.js";
import ResourceList from "./Components/ResourceList";
import Submission from "./Components/Submission.js";

import AboutUs from "./Pages/AboutUs";
import Career from "./Pages/Career";
import Research from "./Pages/Research";
import OurTeam from "./Pages/OurTeam";
import Contact from "./Pages/Contact";
import SoloPage from "./Components/SoloPage";
import Resources from "./Pages/Resources.js";
import NotFound from "./Pages/PageNotFound.js";
import Donate from "./Pages/Donate.js";

function Home() {
    return (
        <>
            <div className="Hero">
                <Hero />
            </div>
            <div className="MemberCarousel">
                <MemberCarousel />
            </div>
            <div className="ResearchSlide">
                <Slide />
            </div>
            <div className="BottomHero">
                <BottomHero />
            </div>
            <div className="AlumContact">
                <AlumContact />
            </div>
        </>
    );
}

function App() {
    return (
        <div>
            <Router>
                <div className="App">
                    <NavBar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/AboutUs" element={<AboutUs />} />
                        <Route path="/Career" element={<Career />} />
                        <Route path="/Research" element={<Research />} />
                        <Route path="/OurTeam" element={<OurTeam />} />
                        <Route path="/Upload" element={<Contact />} />
                        <Route path="/Submission" element={<Submission />} />
                        <Route path="/Team/:pageId" element={<SoloPage />} />
                        <Route path="/Resources" element={<ResourceList />} />
                        <Route
                            path="/Resources/:resourcePageId"
                            element={<Resources />}
                        />
                        <Route path="/Resources" element={<Resources />} />
                        <Route path="/Donate" element={<Donate />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                    <Footer />
                </div>
            </Router>
        </div>
    );
}

export default App;
